module.exports = __webpack_public_path__ + "BG-01.431a2d7.basis";